import React from 'react'
import styled from 'styled-components'

const StyledDots = styled.span`
    margin: 0 4px;
    font-weight: bold;
    color: #1E4564;
    width: 19px;
    height: 32px;
    text-align: center;
`

const Dots = () => <StyledDots>&hellip;</StyledDots>

export default Dots
